import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})
export class TextareaComponent implements ControlValueAccessor {
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() name: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() rows: number = 2;
  @Input() cols: number | null = null;
  @Input() maxlength: number | null = null;
  @Input() minlength: number | null = null;
  @Input() autocomplete: string = '';
  @Input() class: string = '';
  @Input() id: string = '';
  @Input() resize: 'none' | 'both' | 'horizontal' | 'vertical' = 'vertical';

  value: string = '';
  touched: boolean = false;
  characterCount: number = 0;

  // ControlValueAccessor implementation
  onChange = (value: string) => {};
  onTouched = () => {};

  writeValue(value: string): void {
    this.value = value || '';
    this.updateCharacterCount();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInput(event: any): void {
    const value = event.target.value;
    this.value = value;
    this.updateCharacterCount();
    this.onChange(value);
  }

  onBlur(): void {
    this.touched = true;
    this.onTouched();
  }

  onFocus(): void {
    if (!this.touched) {
      this.touched = true;
    }
  }

  private updateCharacterCount(): void {
    this.characterCount = this.value ? this.value.length : 0;
  }

  getCharacterCountClass(): string {
    if (!this.maxlength) return '';

    const percentage = (this.characterCount / this.maxlength) * 100;
    if (percentage >= 90) return 'text-danger';
    if (percentage >= 75) return 'text-warning';
    return 'text-muted';
  }

  getRemainingCharacters(): number {
    if (!this.maxlength) return 0;
    return Math.max(0, this.maxlength - this.characterCount);
  }
}
